<template>
    <div>
        <div class="py-3" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="d-flex justify-content-center">Approval</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-5">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h3>Approve / Dissapprove</h3>
                        <textarea>Comment</textarea>
                        <div @click="submitApproval">Approval Button</div>
                        <div>Disapprove Button</div>
                    </div>
                    <div class="col-md-6">
                        <h3>Comments</h3>
                        {{comments}}
                    </div>
                    <div class="col-md-6">
                        <h3>Audit History</h3>
                        <div class="history">
                            <div stlye="outline-style: dotted;" v-for="s in snapShots">
                                <div class="snapshot-details">
                                    <span class="key-style">Created Date: </span>{{s.createdDate}}<br />
                                    <span class="key-style">Created By: </span> {{s.createdBy}} <br />
                                    <span class="key-style">Status: </span>{{s.currentExpenseReportStatusName}}<br />
                                    <span class="key-style">Version: </span> {{s.expenseReportVersionId}}<br />
                                </div>

                                <!-- Trip Profile -->
                                <h5>Trip Profile Changes</h5>
                                <SnapShotComponent v-for="sSD in s.tripSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>


                                <div v-for="d in s.tripSnapshot.destinations">
                                    <div class="key-style">Destination ID {{d.id}} Changes</div>
                                    <SnapShotComponent v-for="sSD2 in d.snapshotDetails" :snapshot="sSD2"></SnapShotComponent>
                                    <SnapShotComponent v-for="sSD2 in d.personalDates" :snapshot="sSD2"></SnapShotComponent>
                                </div>
                                <!-- Trip Profile End -->
                                <!-- AIRFARE -->
                                <h5>Airfare Changes</h5>
                                <SnapShotComponent v-for="sSD in s.airfareSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>

                                <div v-for="d in s.airfareSnapshot.airfareBaggages">
                                    <div class="key-style">Baggage ID {{d.id}} Changes</div>
                                    <SnapShotComponent v-for="sSD2 in d.snapshotDetails" :snapshot="sSD2"></SnapShotComponent>
                                </div>

                                <div v-for="d in s.airfareSnapshot.airfareTickets">
                                    <div class="key-style">Ticket ID {{d.id}} Changes</div>
                                    <SnapShotComponent v-for="sSD2 in d.snapshotDetails" :snapshot="sSD2"></SnapShotComponent>
                                </div>
                                <!-- AIRFARE End-->
                                <!-- lodging -->
                                <h5>Lodging Changes</h5>
                                <SnapShotComponent v-for="sSD in s.lodgingSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>

                                <div v-for="d in s.lodgingSnapshot.lodges">
                                    <div class="key-style">Hotel ID {{d.id}} Changes</div>
                                    <SnapShotComponent v-for="sSD2 in d.snapshotDetails" :snapshot="sSD2"></SnapShotComponent>
                                </div>
                                <!-- lodging end -->
                                <!-- meals -->
                                <h5>Meal Changes</h5>
                                <SnapShotComponent v-for="sSD in s.mealsSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>
                                <div v-for="(d, dIndex) in s.mealsSnapshot.mealDates">
                                    <div class="key-style">Day ID {{d.id}} Changes</div>
                                    <SnapShotComponent v-for="sSD2 in d.snapshotDetails" :snapshot="sSD2"></SnapShotComponent>
                                    <div v-for="e in d.meals">
                                        <div class="key-style">Meal ID {{e.id}} Changes</div>
                                        <SnapShotComponent v-for="sSD3 in e.snapshotDetails" :snapshot="sSD3"></SnapShotComponent>
                                        <div v-for="f in e.exceptions">
                                            <SnapShotComponent v-for="sSD5 in e.snapshotDetails" :snapshot="sSD5"></SnapShotComponent>
                                        </div>
                                    </div>
                                </div>
                                <!-- meals end -->
                                <!-- rental -->
                                <h5>Rental Car Changes</h5>
                                <SnapShotComponent v-for="sSD in s.carRentalSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>

                                <div v-for="d in s.carRentalSnapshot.fuelCosts">
                                    <div class="key-style">Fuel ID {{d.id}} Changes</div>
                                    <SnapShotComponent v-for="sSD2 in d.snapshotDetails" :snapshot="sSD2"></SnapShotComponent>
                                </div>

                                <div v-for="d in s.carRentalSnapshot.rentalCars">
                                    <div class="key-style">Rental ID {{d.id}} Changes</div>
                                    <SnapShotComponent v-for="sSD2 in d.snapshotDetails" :snapshot="sSD2"></SnapShotComponent>
                                </div>
                                <!-- rental end -->
                                <!-- other -->
                                <h5>Other Changes</h5>
                                <SnapShotComponent v-for="sSD in s.transportationSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>

                                <SnapShotComponent v-for="sSD in s.expenseReportMiscSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>
                                <!-- other end -->
                                <!-- review -->
                                <h5>Review</h5>
                                <SnapShotComponent v-for="sSD in s.expenseReportSubmissionSnapshot.snapshotDetails" :snapshot="sSD"></SnapShotComponent>
                                <!-- review end -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    h3 {
        font-weight: 400;
    }

    h5 {
        font-weight: 400;
        margin-bottom: 0;
    }

    .snapshot-details {
        margin-left: 25px;
        margin-bottom: 5px;
    }

    .key-style {
        font-weight: 400;
    }

    .history {
        max-height: 400px;
        overflow: auto;
    }
</style>

<script>
    import SnapShotComponent from '@/components/SnapShotComponent.vue'
    import SnapShotService from '@/services/SnapShotService'
    import ApprovalService from '@/services/ApprovalService'

    export default {
        components: {
            SnapShotComponent
        },
        async created() {
            this.expenseReportID = this.$route.params.erid;
            this.comments = await ApprovalService.getAllComments(this.expenseReportID);
            this.snapShots = await SnapShotService.getAllSnapshots(this.expenseReportID);
            this.getSummaryCosts(this.expenseReportID);
        },
        data() {
            return {
                expenseReportID: null,
                snapShots: null,
                comments: null,
                summaryCosts: null
            }
        },
        methods: {
            async submitApproval() {
                await ApprovalService.submitApproval(this.expenseReportID);
            },
            getSummaryCosts(erID) {
                this.$http
                    .get(`expensereports/${erID}/Review`, {
                        headers: {
                            "Authorization": "Bearer " + this.msal.accessToken
                        }
                    })
                    .then(response => {
                        this.summaryCosts = response.data;
                    })
                    .catch(error => {
                        this.$notify({
                            group: 'errors',
                            type: 'error',
                            title: 'Error',
                            text: error
                        });
                        this.errored = true
                    })
            }
        }
    }
</script>